/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

type InviteIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const InviteIcon: React.FC<InviteIconProps> = ({
  title = 'Storefront',
  viewBox = '0 0 24 24',
  ...props
}) => (
  <CreateIconComponent viewBox={viewBox} title={title} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.049 0.996746C11.605 0.556667 12.395 0.556668 12.951 0.996746L14.9527 2.58104H19.7811C20.6219 2.58104 21.3035 3.2554 21.3035 4.08726V7.60773L22.762 8.76213C23.1231 9.04796 23.3334 9.48072 23.3334 9.93828V21.8271C23.3334 22.659 22.6518 23.3334 21.811 23.3334H2.18907C1.34828 23.3334 0.666687 22.659 0.666687 21.8271V9.93828C0.666687 9.48072 0.876914 9.04796 1.23805 8.76213L2.69654 7.60773V4.08726C2.69654 3.2554 3.37813 2.58104 4.21893 2.58104H9.04736L11.049 0.996746ZM3.03485 11.5339V20.9904H20.9652V11.5339L12.6988 15.7595C12.2605 15.9836 11.7396 15.9836 11.3012 15.7595L3.03485 11.5339ZM5.0647 4.92404V9.93431L12 13.4795L18.9353 9.93431V4.92404H5.0647ZM7.60201 7.09969C7.60201 6.54511 8.05641 6.09554 8.61694 6.09554H15.3831C15.9436 6.09554 16.398 6.54511 16.398 7.09969C16.398 7.65426 15.9436 8.10383 15.3831 8.10383H8.61694C8.05641 8.10383 7.60201 7.65426 7.60201 7.09969ZM9.63186 9.10798C9.07133 9.10798 8.61694 9.55755 8.61694 10.1121C8.61694 10.6667 9.07133 11.1163 9.63186 11.1163H14.3682C14.9287 11.1163 15.3831 10.6667 15.3831 10.1121C15.3831 9.55755 14.9287 9.10798 14.3682 9.10798H9.63186Z"
    />
  </CreateIconComponent>
);

export default InviteIcon;
